import {
  APP_START,
  ROUTER_LOCATION_CHANGE,
  SET_ERROR,
} from "../actions/app.actions";
import {
  AUTHORIZE_DONE,
  USERINFO_LOADED,
  authorizeAction,
  getUserInfoAction,
  updateAuth,
} from "../actions/auth.actions";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setOnLocalStorage,
} from "../libs/helpers/localstorage";

import generatePermFromScopes from "../libs/helpers/generatePermFromScopes";
import { refreshPage } from "../libs/utils";
import { get, register } from "../libs/helpers/ioc";

const getStateAuthInfo = (store) =>
  (store.getState() && store.getState().auth) || {};

const checkUser = (store) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant");

  const storageInfoId = ls && ls.user && (ls.user.uid || ls.user._id);
  const storageInfoToken = ls && ls.token;

  const { user, token } = getStateAuthInfo(store);

  const userID = user ? user.uid || user._id : null;

  if (storageInfoId && userID && userID !== storageInfoId) {
    refreshPage();
  } else if (token) {
    // Already authenticated in this tab; this branch just needs to match so
    // we don't fall through to the localStorage-clearing branch below.
  } else if (
    (!token || token !== storageInfoToken) &&
    storageInfoToken &&
    storageInfoId
  ) {
    if (ls.scopes) {
      console.log("setting scopes from ls ??");
      const scopes = tenant ? ls.scopes[tenant.data] : [];
      register("scopes", generatePermFromScopes(scopes));
    }
    store.dispatch(
      updateAuth({ user: ls.user, token: ls.token, scopes: ls.scopes }),
    );
  } else {
    removeFromLocalStorage(null, "general");
    // removeFromLocalStorage(null, "lefacWebTenant");
  }
};

const checkQueryParams = (store) => {
  let { hash, search } = window.location;

  const urlParams = new URLSearchParams(search);
  const query = Object.fromEntries(urlParams);

  if (query && (query.authorization_code || query.code)) {
    store.dispatch(
      authorizeAction({ code: query.authorization_code || query.code }),
    );
    return true;
  }
  if (query && query.logout === "OK") {
    window.location = "/";
  } else if (hash) {
    [, hash] = hash.split("#");
    const params = {};
    hash.split("&").forEach((t) => {
      const [k, v] = t.split("=");
      params[k] = v;
    });
  }
  return false;
};

const authMiddleware = (store) => (next) => (action) => {
  if (action.type === APP_START) {
    if (!checkQueryParams(store)) {
      checkUser(store);
    }
  } else if (action.type === AUTHORIZE_DONE) {
    const { user, token, scopes } = action.data;
    if (user && token) {
      setOnLocalStorage(action.data);
      const scopes_ = get("scopes");
      if (scopes && !scopes_) {
        console.log("setting scopes from AUTHORIZE_DONE");
        const tenant = getFromLocalStorage("lefacWebTenant");
        const currentScopes = tenant ? scopes[tenant.data] : [];
        register("scopes", generatePermFromScopes(currentScopes));
      }
      next(action);
      store.dispatch(getUserInfoAction());
      return;
    } else {
      console.error("ERROR", "Session not saved");
      return window.location.replace("/login");
    }
  } else if (action.type === USERINFO_LOADED) {
    if (action.data) {
      setOnLocalStorage({ user: action.data });
      if (action.data.scopes) {
        console.log("setting scopes from USERINFO_LOADED");
        const _tenant = getFromLocalStorage("lefacWebTenant");
        const currentScopes = _tenant ? action.data.scopes[_tenant.data] : [];
        register("scopes", generatePermFromScopes(currentScopes));
      }
    } else {
      console.error("ERROR", "Session not saved");
      return window.location.replace("/login");
    }
  } else if (action.type === SET_ERROR) {
    // next(action);
    // store.dispatch(push("/error"));
  } else if (action.type === ROUTER_LOCATION_CHANGE) {
    window.scrollTo(0, 0);
    checkUser(store);
  }

  next(action);
};

export default authMiddleware;
